import { render, staticRenderFns } from "./RegistrationPage.vue?vue&type=template&id=a1634a90&scoped=true&"
import script from "./RegistrationPage.vue?vue&type=script&lang=ts&"
export * from "./RegistrationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1634a90",
  null
  
)

export default component.exports